import axios from 'axios';

function brandFilteringCat(e) {
  e.preventDefault();
  // const { action } = e.currentTarget.parentElement;
  const { brand } = e.currentTarget.dataset;
  const { cat } = e.currentTarget.dataset;
  const innerProduct = document.querySelector('.allproducts');
  innerProduct.innerHTML = `<p class='waait'>لطفاً کمی منتظر باشید.....</p>`;
  innerProduct.classList.remove(
    'wrapper-cards-product',
    'allproducts',
    'inner-grid'
  );
  axios
    .get(`/api/cat/brand`, {
      params: { draftMode: false, cat: `${cat}`, brand: `${brand}` },
    })
    .then((response) => {
      console.log(response);
      for (let i = 0; i < response.data.productsForCat.length; i++) {
        const singleData = response.data.productsForCat[i];
        if (singleData.brand.includes(brand)) {
          const imageName = `${singleData.productPhotoOne.path
            .split('.')
            .slice(0, -1)
            .join('.')}`;

          const htmlResult = `
            <a class="inner-wrapper-card-product" href="/${singleData.proSubCat[0].subcat}/${singleData.slug}">
              <picture>
                <source media="(max-width: 600px)" type="image/webp" srcset="/images/blog_images/${imageName}-600.webp" sizes="600px">
                <source media="(min-width: 601px) and (max-width: 900px)" type="image/webp" srcset="/images/blog_images/${imageName}-900.webp" sizes="900px">
                <source media="(min-width: 901px) and (max-width: 1200px)" type="image/webp" srcset="/images/blog_images/${imageName}-1200.webp" sizes="1200px">
                <source media="(min-width: 1201px)" type="image/webp" srcset="/images/blog_images/${imageName}-1800.webp" sizes="1800px">
                <source media="(max-width: 600px)" type="image/jpeg" srcset="/images/blog_images/${imageName}-600.jpg" sizes="600px">
                <source media="(min-width: 601px) and (max-width: 900px)" type="image/jpeg" srcset="/images/blog_images/${imageName}-900.jpg" sizes="900px">
                <source media="(min-width: 901px) and (max-width: 1200px)" type="image/jpeg" srcset="/images/blog_images/${imageName}-600.jph" sizes="1200px">
                <source media="(min-width: 1201px)" type="image/jpeg" srcset="/images/blog_images/MLG-44-1800.jpg" sizes="1800px"><img src="/images/blog_images/${imageName}-1200.webp" alt="${singleData.productPhotoOneAlt}" width="177" height="250">
              </picture>
              <div class="inner-wrapper-card-title">
                <span>${singleData.title}</span>
                <div class="product-detail-button">بررسی محصول</div>
              </div></a>
          `;
          innerProduct.classList.add(
            'wrapper-cards-product',
            'allproducts',
            'inner-grid'
          );
          innerProduct.insertAdjacentHTML('afterbegin', htmlResult);
        }
        // if (brand === response.data.brandProduct[0].title) {
        //   console.log(singleData);
        // }
      }
      const waait = document.querySelector('.waait');
      waait.remove();
    })
    .catch((err) => {
      console.log(err);
    });
}

export default brandFilteringCat;



// WEBPACK FOOTER //
// ./public/javascripts/modules/brandfilteringCat.js